define('Components/Loyalty/js/views/blocks/LoyaltyProfileView',['backbone', 'underscore', 'app', 'site_vars',
    'views/pages/account/AccountView',
    'template!Components/Loyalty/templates/loyalty',
    'formatPrice',
    'InternalLinkView',
    'moment',
    'momentFormats'


], function (Backbone, _, app, site_vars,
             AccountView,
             loyaltyTemplate,
             formatPrice,
             InternalLinkView,
             moment,
             momentFormats
) {

   var activeCode,
       codesLength;

   return AccountView.extend({
       events:{
           'click .account-codes-nav': 'navClick'
       },
       initialize:function(){

           this.render();

       },

       render:function(){

           activeCode = 0;

           var view = this,
               customer = app.getCustomer(),
               customer_loyalty,
               customer_loyalty_history,
               customer_loyalty = customer.get('customer_loyalty'),
               customer_loyalty_history = customer.get('customer_loyalty_history'),
               customer_quantity = 0,
               customer_amount = 0;

           if (customer_loyalty && customer_loyalty.quantity){
               customer_quantity = customer_loyalty.quantity;
           }

           // TODO : Danger Zone ! `ammount` with 2 `m`
           if (customer_loyalty && customer_loyalty.ammount){
               customer_amount = customer_loyalty.ammount;
           }
           customer_amount = formatPrice(customer_amount);

           _(customer_loyalty_history).each(function (e) {
               var m = moment(e.date_add),
                   dateFormated = m.isValid() ? m.calendar(null,momentFormats.getFormats()) : '-';
               e.datef = dateFormated;
           });

           view.$el.html(loyaltyTemplate({
                   customer: customer,
                   customer_quantity:customer_quantity,
                   customer_amount:customer_amount ,
                   customer_historique:_(customer_loyalty_history) ,
               }
           ));
           codesLength = view.$('.account-codes-slider li').length;
           InternalLinkView.initializeLinksOfView(view);
       },

       navClick: function(e){
           var view = this;
           if($(e.currentTarget).hasClass('account-codes-prev')){
               activeCode = activeCode > 0 ? activeCode - 1 : codesLength - 1;
           }else{
               activeCode = activeCode < codesLength - 1 ? activeCode + 1 : 0;
           }
           view.$('.account-codes-slider ul').css('left', -activeCode * 100 + '%')
       }
   });
});
